import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ApiService from "../../../services/api/ApiService";
import { handleErrorMessages } from "../../../utils/common-functions";

export const getHeaderFooterData = createAsyncThunk(
  "getHeaderFooterData",
  async (data, { rejectWithValue }) => {
    try {
      const response = await ApiService.get(`/footer/`);
      return response.data;
    } catch (error) {
      return rejectWithValue(handleErrorMessages(error.data));
    }
  }
);

const headerFooterDataSlice = createSlice({
  name: "headerFooterData",
  initialState: {
    headerFooterDataList: {},
    loading: false,
  },
  reducers: {
    setLoading: (state, action) => {
      state.loading = { ...state.loading, ...action.payload };
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getHeaderFooterData.fulfilled, (state, action) => {
        state.headerFooterDataList = action.payload;
        state.loading = false;
      })
      .addCase(getHeaderFooterData.pending, (state, action) => {
        state.loading = true;
      });
  },
});

export default headerFooterDataSlice.reducer;

export const { setLoading } = headerFooterDataSlice.actions;
